import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import { LightBoxContext } from './LightBoxContext';

const LightBoxModal = () => {
  let { lightBoxContent, lightBox } = useContext(LightBoxContext);
  if (lightBox) {
    return ReactDOM.createPortal(lightBoxContent, document.querySelector('#lightbox-root'));
  } else return null;
};

export default LightBoxModal;
